#import './onboarding-step-fragment.graphql'

fragment OnboardingModuleFragment on OnboardingModule {
    name
    type
    status
    description
    isComplete
    steps {
        ...OnboardingStepFragment
    }
}
